import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';

const GOOGLE_RECAPTCHA_SITE_KEY = process.env.GOOGLE_RECAPTCHA_SITE_KEY;

export default class GoogleRecaptchaInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            response: props.value || ''
        };
    }

    triggerChange(changedValue) {
        const { onChange } = this.props;
        if (onChange) {
            onChange(changedValue);
        }
    }

    handleVerifyCallback(response) {
        if (!('value' in this.props)) {
            this.setState({ response });
        }
        this.triggerChange(response);
    }

    componentWillReceiveProps(nextProps) {
        if ('value' in nextProps) {
            const value = nextProps.value;
            this.setState({ response: value });
        }
    }

    render() {
        const { onChange } = this.props;

        return (
            <Recaptcha
                render="explicit"
                sitekey={GOOGLE_RECAPTCHA_SITE_KEY}
                onloadCallback={() => {}}
                verifyCallback={(res) => this.handleVerifyCallback(res)}
                expiredCallback={() => onChange(undefined)}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/GoogleRecaptchaInput/GoogleRecaptchaInput.js